module.exports = __webpack_public_path__ + "img/btn-gray.55c75e53.png";